module.exports = __webpack_public_path__ + "static/media/Rocket.4f66c01e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Rocket.svg
// module id = 1121
// module chunks = 0